// extracted by mini-css-extract-plugin
export default {"icon":"bottomBar_icon__wDVSv","iconSelected":"bottomBar_iconSelected__3F3Rb","tools":"bottomBar_tools__e8-6Y","button":"bottomBar_button__QXQqu"};